"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CmpBottomNavigation = void 0;
const gs = require("@ivanlog/gs");
const gs_1 = require("@ivanlog/gs");
const App_1 = require("../App");
const tmpls_1 = require("./tmpls");
const StateProfile_1 = require("../../appProfiMall/states/StateProfile");
class CmpBottomNavigation extends tmpls_1.CmpBottomNavigationBase {
    constructor() {
        super();
        const ctrl = this.ctrls;
        ctrl.btnProfile.addClass(gs_1.StateGS.LinkCatchedClassName); //вешаем, чтобы фреймворк не перехватывал
        ctrl.btnProfile.onclick = (e) => {
            gs.events.stop(e);
            if (!App_1.App.Inst.auth.user) {
                App_1.App.Inst.auth.authAsync((result) => {
                    if (!result)
                        return;
                    gs.StateGS.Run(StateProfile_1.StateProfile);
                    return;
                });
            }
            else
                gs.StateGS.Run(StateProfile_1.StateProfile);
        };
    }
    initialize(topMenu) {
        const ctrl = this.ctrls;
        ctrl.btnCatalog.onclick = () => topMenu.openCatalog();
    }
}
exports.CmpBottomNavigation = CmpBottomNavigation;
//# sourceMappingURL=CmpBottomNavigation.js.map